module.exports = __webpack_public_path__ + "img/104004.1d4664cc.png";